<template>
    <svg height="64" width="64" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
        <!-- @vue-ignore @赵缙翔 volar bug -->
        <g fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-width="1.275142">
            <path d="m9 14.2462998v-2.6231499c0-1.4487257 1.1744242-2.6231499 2.6231499-2.6231499h2.6231499" />
            <path
                d="m18.0933008 14.2462998v-2.6231499c0-1.4487257 1.1744242-2.6231499 2.6231499-2.6231499h2.6231499"
                transform="matrix(-1 0 0 1 41.432902 0)"
            />
            <path
                d="m9 22.9901328v-2.6231499c0-1.4487257 1.1744242-2.6231499 2.6231499-2.6231499h2.6231499"
                transform="matrix(1 0 0 -1 0 40.733966)"
            />
            <path
                d="m18.0933008 22.9901328v-2.6231499c0-1.4487257 1.1744242-2.6231499 2.6231499-2.6231499h2.6231499"
                transform="matrix(-1 0 0 -1 41.432902 40.733966)"
            />
            <path d="m12.716129 16h6.557875" />
        </g>
    </svg>
</template>
